import { Link } from "react-router-dom";

export function CompanyHeader({ kicker, title, subtitle }) {
    return (
        <section className="bg-lavender px-5 pb-12 pt-36 sm:pb-16 sm:pt-44">
            <div className="mx-auto max-w-5xl">
                <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[var(--brand)] ring-1 ring-black/5">
                    {kicker}
                </span>
                <h1 className="mt-5 font-display text-4xl font-extrabold leading-tight text-[#0a0a0b] sm:text-5xl">
                    {title}
                </h1>
                {subtitle ? (
                    <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-[#5b5b66] sm:text-lg">
                        {subtitle}
                    </p>
                ) : null}
            </div>
        </section>
    );
}

export function CompanyTabs({ tabs, active, onChange, testId = "company-tabs" }) {
    return (
        <div
            data-testid={testId}
            className="flex flex-wrap gap-2"
            role="tablist"
        >
            {tabs.map((tab) => {
                const on = tab.id === active;
                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={on}
                        data-testid={`tab-${tab.id}`}
                        onClick={() => onChange(tab.id)}
                        className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                            on
                                ? "bg-[var(--brand)] text-white shadow-[0_8px_20px_rgba(43,80,255,0.28)]"
                                : "bg-white text-[#4b4b55] ring-1 ring-black/5 hover:text-[var(--brand)]"
                        }`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
}

export function SmartLink({ href, className = "", children, testId }) {
    const external = href.startsWith("http");
    const staticPath = href.startsWith("/hvac-recovery");
    if (external || staticPath) {
        return (
            <a
                href={href}
                data-testid={testId}
                className={className}
                {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
            >
                {children}
            </a>
        );
    }
    return (
        <Link to={href} data-testid={testId} className={className}>
            {children}
        </Link>
    );
}

export const offerBtn =
    "inline-flex items-center justify-center rounded-full bg-[var(--brand)] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_8px_20px_rgba(43,80,255,0.28)] transition-transform hover:-translate-y-0.5";

export const offerBtnGhost =
    "inline-flex items-center justify-center rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[#0a0a0b] ring-1 ring-black/10 transition-colors hover:text-[var(--brand)]";
